import App from './App.svelte';

const root = document.getElementById('sizeometer');

export default new App({
  target: root,
});
